import React from 'react';
import { Dialog, DialogContent, DialogActions, Typography, makeStyles } from '@material-ui/core';
import Controls from "../Controls/Controls";

const useStyles = makeStyles(theme => ({
  dialog: {
    padding: theme.spacing(1),
    position: 'absolute',
    top: theme.spacing(5),
    border: 6,
    borderColor: 'red',
    borderRadius: 18,
    color: 'black',
  },

  dialogTitle: {
    textAlign: 'center'
  },

  dialogContent: {
    textAlign: 'center'
  },
}))

export default function NotificationCustom(props) {
  const { notificationCustom } = props;
  const classes = useStyles();

  return (
    <Dialog open={notificationCustom.isOpen} classes={{ paper: classes.dialog }}>

      <DialogContent className={classes.dialogContent}>
        <Typography variant="h6">
          {notificationCustom.title}
        </Typography>
      </DialogContent>

      <DialogActions className={classes.dialogAction}>
        <Controls.ButtonT
          text="OK"
          variant="outline-info"
          onClick={
            notificationCustom.onConfirm
          }
        />
      </DialogActions>
    </Dialog>
  )
}
